var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraffickingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.09351L18 11.5935C18 14.0788 15.9853 16.0935 13.5 16.0935C11.0147 16.0935 9 14.0788 9 11.5935L9 4.5935C9 3.2128 7.8807 2.0935 6.5 2.0935C5.1193 2.0935 4 3.2128 4 4.5935L4 11.2642C5.1652 11.676 6 12.7873 6 14.0935C6 15.7504 4.6569 17.0935 3 17.0935C1.3431 17.0935 1.17422e-07 15.7504 2.62268e-07 14.0935C3.76462e-07 12.7873 0.834801 11.676 2 11.2642L2 4.5935C2 2.1082 4.0147 0.0935044 6.5 0.0935046C8.9853 0.0935048 11 2.1082 11 4.5935L11 11.5935C11 12.9742 12.1193 14.0935 13.5 14.0935C14.8807 14.0935 16 12.9742 16 11.5935L16 5.09351L13 5.09351L17 0.0935055L21 5.09351L18 5.09351ZM3 13.0935C2.4477 13.0935 2 13.5412 2 14.0935C2 14.6458 2.4477 15.0935 3 15.0935C3.5523 15.0935 4 14.6458 4 14.0935C4 13.5412 3.5523 13.0935 3 13.0935Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraffickingIcon);
export default __webpack_public_path__ + "static/media/trafficking-icon.7011b5ecfffe6d451ff99058bc406d69.svg";
export { ForwardRef as ReactComponent };